import { render, staticRenderFns } from "./CategoriesAction.vue?vue&type=template&id=fe0c1fac&scoped=true&"
import script from "./CategoriesAction.vue?vue&type=script&lang=js&"
export * from "./CategoriesAction.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesAction.vue?vue&type=style&index=0&id=fe0c1fac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0c1fac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
